<!--
 * @Author: your name
 * @Date: 2021-08-13 17:04:31
 * @LastEditTime: 2022-04-27 14:51:16
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/components/Return.vue
-->
<template>
  <div class="app">
    <div class="Ret" @click="clickTab"><span>返回首页</span></div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    clickTab() {
      this.$router.push({
        path: "/BindingMenmberCard"
      });
    }
  }
};
</script>
<style scoped>
.app {
  width: 0;
  height: 0;
}
.Ret {
  position: fixed;
  z-index: 9;
  bottom: 170px;
  left: 0px;
  width: 24%;
  height: 20px;
  background: #fff;
  line-height: 20px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  color: #212121;
  box-shadow: 0px 0px 0.8px 0px #757575;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Return.vue